module.exports = __webpack_public_path__ + "static/media/HTML.f2282f94.png";